var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"auto","color":"#000000","background-color":"#ff8282","height":"25px","line-height":"25px","text-align":"center","border-radius":"25px","width":"80px"}},[_vm._v(" 欢迎! ")])}
var staticRenderFns = []

export { render, staticRenderFns }